module.exports = "<div id=\"map\"></div>"


//////////////////
// WEBPACK FOOTER
// /home/azu/Proyectos/impunidad/impunidad-cero-tai/src/app/dboxMap/dboxMap.component.html
// module id = ../../../../../src/app/dboxMap/dboxMap.component.html
// module chunks = main